<template>
  <div>
    <ElectiveBanner />
    <MasterView />
    <OurPlacement />
    <FirmsTrust />
    <RecognitionsView />
    <AluminaiView />
    <KeyTakeaway />
    <OurBlogs />
    <ElectiveFaq v-if="this.programFaq" :faq="this.programFaq" />
    <FooterView />
    <!-- floating contact elements -->
    <SocialMedia />
  </div>
</template>

<script>
import ElectiveBanner from "@/components/ElectiveListing/ElectiveBanner.vue";
import MasterView from "@/components/ElectiveListing/MasterView.vue";
import OurPlacement from "@/components/ElectiveListing/OurPlacement.vue";
import KeyTakeaway from "@/components/ElectiveListing/KeyTakeaway.vue";
import FirmsTrust from "@/components/ElectiveListing/FirmsTrust.vue";
import RecognitionsView from "@/components/AllProgram/RecognitionsView.vue";
import OurBlogs from "@/components/Home/OurBlogs.vue";
import AluminaiView from "@/components/Home/AluminaiView.vue";
import ElectiveFaq from "@/components/ElectiveListing/ElectiveFaq.vue";
import FooterView from "@/components/Home/FooterView.vue";
import SocialMedia from "@/components/SocialMedia.vue";
import axios from "axios";

export default {
  name: "ProgramView",
  components: {
    ElectiveBanner,
    MasterView,
    OurPlacement,
    FirmsTrust,
    RecognitionsView,
    KeyTakeaway,
    AluminaiView,
    OurBlogs,
    ElectiveFaq,
    FooterView,
    SocialMedia,
  },
  data() {
    return {
      programFaq: "",
    };
  },
  created() {
    this.programCall();
  },
  methods: {
    async programCall() {
      const slug = this.$route.params.slug;
      await axios
        .get(`${process.env.VUE_APP_API}/course/program-list/?slug=${slug}`)
        .then((resp) => {
          console.log(resp.data)
          if (resp.data.data){
          this.programFaq = resp.data.data[0].slug;
          }
        });
    },
  },
};
</script>

<style></style>
